import { useUser } from "../context/UserContext";
import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

export const ProtectedRoute = ({ redirectPath = "/login", children }) => {
  const { isLoggedIn, setAsaData } = useUser();
  const [searchParams, setSearchParams] = useSearchParams();
  const params = [];

  var location = useLocation();

  useEffect(() => {
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    // this is ASA directed link
    if(params['user_id']){
      //Todo: check if unique_task_id and step_number are also present. 
      console.log("Params: ", params)
      setAsaData(params);
    }
  }, []); // run this once to set ASA data



  if (!isLoggedIn) {
   
    return <Navigate to={redirectPath}  state={{ from: location }} replace />;
  }

  return children ? children : <Outlet />;
};